import CheckoutView from "./view";
import { useSelector } from "react-redux";
import { ReducersTypes } from "../../redux/reducers/Models";
import { PropsView } from "../home/Models";
import useRedirect from "@/hooks/useRedirect";
import { useNavigate } from "react-router-dom";

export default function Checkout() {
  useRedirect("checkout");

  const navigate = useNavigate();

  const user = useSelector((state: ReducersTypes & {
    userReducer: ReducersTypes['userReducer'] & {
      cart: PropsView['selectables']
    }
  }) => state.userReducer);

  const goToCard = () => navigate('/checkout/user/card');

  const goToPix = () => navigate('/checkout/user/pix');
  
  const goBack = () => navigate(-1);
  
  return (
    <CheckoutView
      goToCard={goToCard}
      goToPix={goToPix}
      goBack={goBack}
      selectables={user?.cart}
      plate={user?.plate as string}
      items={user?.debts as PropsView['items']}
    />
  );
}
